import React from "react";
import styles from "./payment.module.css";

/**
 * Single mount point for the active (non-express) Adyen component + loading overlay.
 */
export default function PaymentMethodRenderer({ mounting, mountRef }) {
  return (
    <div className={styles.rendererWrap}>
      {mounting ? (
        <div className={styles.mountSkeleton} aria-busy="true">
          <div className={styles.skelBar} />
          <div className={styles.skelBarShort} />
        </div>
      ) : null}
      <div ref={mountRef} id="payment-container" className={styles.adyenMount} />
    </div>
  );
}
